import { FlightEventHandler } from "./flight"
import { navigate } from 'svelte-navigator'
import isPrimaryLink from "../utils/isPrimaryLink"
import * as map from '../map'
import * as L from 'leaflet'
import { writable } from "svelte/store"

export default class OwnshipMarker extends FlightEventHandler {
	arsMarker = null

	constructor(flight) {
		super(flight)

		const { subscribe, set } = writable(null);
		this.subscribe = subscribe
		this.set = set

		this.addedLayer = true
		this.layer = L.layerGroup()
		this.layer.addTo(map.getMap())
		this.overlay = map.addOverlay("Ownship", this.layer, flight.overlay)
	}


	handleKeyframe(keyframe) {
		if (keyframe.droneTrail && keyframe.droneTrail.length > 1) {
			this.setMarkerLocation(keyframe.droneTrail.slice(-2))
		} else {
			this.clearMarker()
		}
	}

	handleFlightStep(message) {
		if (message.type !== 'SKYLINK_ADV_STATUS') return false
		if (!isPrimaryLink(message)) return false
		if (message.data.remote.protocol.radioStatus === 0 || 
            message.data.remote.position.latitude === 0 ||
            !message.data.local.isLead) return false

		const coord = [message.data.remote.position.latitude, message.data.remote.position.longitude]
		this.setMarkerLocation(coord)
	}

	setMarkerLocation(coord) {
		this.set(coord)
		if (this.arsMarker) {
			this.arsMarker.setLatLng(coord)
		} else {
			const icon = L.icon({
				iconUrl: '/images/diamond-thick-blue.png',
				iconSize: [25, 25],
				iconAnchor: [12.5, 12.5]
			})
			this.arsMarker = L.marker(coord, { icon, zIndexOffset: 1100 }).addTo(this.layer)
			this.arsMarker.on('click', () => {
				if (this.flight.multiFlight) {
					navigate(`/flights/${this.flight.flightId}`)
				}
			})
		}
		if (!this.arsMarker.getPopup()) this.arsMarker.bindPopup('Following', { className: 'hidden' })
		if (this.arsMarker.isPopupOpen()) {
			map.getMap().panTo(coord)
		}
	}

	clearMarker() {
		this.set(null)
		if (this.arsMarker) {
			this.arsMarker.removeFrom(this.layer)
			this.arsMarker = null
		}
	}

	cleanup() {
		super.cleanup()
		this.clearMarker()
		if (this.addedLayer) {
			this.layer.removeFrom(map.getMap())
			map.removeOverlay(this.overlay, this.flight.overlay)
		}
	}
}
